import { Form } from "@renderbus/ui";
import { Modal } from "@/components/renderbus-modal";
import { FormInstance, ModalProps } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useValidator } from "@/pages/child-customer/view/child-manage/hooks/useValidator";
import { Input, Switch } from "@renderbus/ui";
import { useGlobalStore } from "@/store/GlobalStore";

export function AddChildModal({
  open,
  modalProps,
  form,
}: {
  open: boolean;
  modalProps: ModalProps;
  form?: FormInstance;
}) {
  const t = getTranslateNsT("center");
  const { isDomestic } = useGlobalStore();
  const {
    subUserNameValidator,
    phoneValidator,
    emailValidator,
    passwordValidator,
  } = useValidator();
  return (
    <Modal
      open={open}
      title={t("user_com_childManage_btn_add_sub")}
      children={
        <Form
          size={"large"}
          colon={false}
          form={form}
          labelCol={{ span: 6 }}
          labelAlign="right"
          autoComplete="new-password"
        >
          <Form.Item
            name="subUserName"
            label={t("user_com_childManage_sub_place")}
            validateTrigger="onBlur"
            required
            rules={[
              {
                validator: (...arg) => subUserNameValidator(arg, false, true),
                validateTrigger: "onBlur",
              },
            ]}
          >
            <Input
              className="background-2C2C31"
              placeholder={t("user_com_childManage_sub_place")}
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item
            name="subPassword"
            label={t("user_com_childManage_psw_place")}
            required
            rules={[
              {
                validator: (...arg) => passwordValidator(arg),
                validateTrigger: "onBlur",
              },
            ]}
          >
            <Input
              type="password"
              placeholder={t("user_com_childManage_psw_place")}
              className="background-2C2C31"
              autoComplete="new-password"
            />
          </Form.Item>
          {isDomestic && (
            <Form.Item
              name="phone"
              label={t("user_com_childManage_tel_place")}
              validateTrigger="onBlur"
              rules={[
                {
                  validator: (...arg) => phoneValidator(arg, true, true),
                  validateTrigger: "onBlur",
                },
              ]}
            >
              <Input
                placeholder={t("user_com_childManage_tel_place")}
                className="background-2C2C31"
                autoComplete="new-password"
              />
            </Form.Item>
          )}
          <Form.Item
            name="email"
            label={t("user_com_childManage_email_place")}
            validateTrigger="onBlur"
            rules={[
              {
                validator: (...arg) => emailValidator(arg, true, true),
                validateTrigger: "onBlur",
              },
            ]}
          >
            <Input
              placeholder={t("user_com_childManage_email_place")}
              className="background-2C2C31"
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item
            name="status"
            label={t("user_com_childManage_btn_to_active")}
          >
            <Switch />
          </Form.Item>
        </Form>
      }
      {...modalProps}
    />
  );
}
